import { render, staticRenderFns } from "./IssuedVisaReport.vue?vue&type=template&id=57ec97bc&"
import script from "./IssuedVisaReport.vue?vue&type=script&lang=js&"
export * from "./IssuedVisaReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports